var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-chart-container"},[_c('vue-apex-charts',{attrs:{"id":"monitoring-chart","height":"125","options":_vm.chartOptions,"type":"bar","series":_vm.healthStatusSeriesComputed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }